<template>
  <section class="brief-step">
    <div class="brief-step__head">
      <span
        class="brief-step__num"
        aria-hidden="true"
      >{{ number }}</span>
      <div class="brief-step__copy min-width-0">
        <div class="d-flex flex-wrap align-center">
          <h2 class="brief-step__title mb-0">
            {{ title }}
          </h2>
          <v-chip
            v-if="optional"
            x-small
            outlined
            class="ml-2 text-none"
          >
            {{ $t('createBrief.optional') }}
          </v-chip>
        </div>
        <p
          v-if="help"
          class="brief-step__help mb-0"
        >
          {{ help }}
        </p>
      </div>
    </div>
    <div class="brief-step__body">
      <slot />
    </div>
  </section>
</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        name: 'BriefStep',
        props: {
            number: {
                type: [Number, String],
                required: true
            },
            title: {
                type: [String, Object],
                required: true
            },
            help: {
                type: [String, Object],
                default: ''
            },
            optional: {
                type: Boolean,
                default: false
            }
        }
    });
</script>

<style scoped lang="sass">
.brief-step
    padding: 20px 0 8px
    border-top: 1px solid rgba(0, 0, 0, 0.08)
    min-width: 0
    max-width: 100%
    &:first-of-type
        border-top: none
        padding-top: 0

.brief-step__body
    width: 100%
    max-width: 100%
    min-width: 0
    box-sizing: border-box

.brief-step__head
    display: flex
    align-items: flex-start
    margin-bottom: 16px

.brief-step__num
    flex: 0 0 28px
    width: 28px
    height: 28px
    margin-right: 12px
    border-radius: 50%
    background: var(--v-primary-base)
    color: #fff
    font-size: 14px
    font-weight: 700
    line-height: 28px
    text-align: center

.brief-step__title
    font-size: 1.05rem
    font-weight: 700
    line-height: 1.3

.brief-step__help
    margin-top: 6px
    color: rgba(0, 0, 0, 0.6)
    font-size: 0.875rem
    line-height: 1.45

.min-width-0
    min-width: 0
</style>
